<template>
  <div class="flex-images">
    <az-image v-for="item in martists" :key="'a' + item.artist_id" :artist="item" :pageSettings="pageSettings" />
    <div v-for="n in extraImages" :key="'xtra' + n" class="imdiv"></div>
  </div>
</template>

<script>
import AzImage from '@/components/widgets/AzImage.vue'
export default {
  components: {
    AzImage
  },
  props: {
    artists: {
      type: Array,
      default: function () { return [] }
    },
    maxInitialChunks: {
      type: Number,
      default: 4
    }
  },
  data: function () {
    return {
      martists: [],
      extraImages: 0,
      rowWidth: 5,
      version: 1,
      loadedChunks: 0,
      maxChunks: 0,
      scrolled: false,
      initialLoadComplete: false,
      pageSettings: ''
    }
  },
  computed: {
    chunkSize: function () {
      return this.rowWidth * 4;
    }
  },
  created () {
    this.loadedArtists()

  },
  mounted: function () {
    window.addEventListener('resize', this.setExtraImages)
    window.addEventListener('scroll', this.windowScrolled)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setExtraImages)
    window.removeEventListener('scroll', this.windowScrolled)
  },
  methods: {
    windowScrolled: function () {
      if(!this.scrolled) {
        if(this.maxChunks > this.loadedChunks){
          if((window.scrollY > 400) && this.initialLoadComplete) {
            this.scrolled = true
            this.finishLoading()
          }

        }
      }
    },
    setExtraImages: function () {
      this.rowWidth = this.$k.getBreakpoint().columns
      const extra = this.martists.length % this.rowWidth
      if(extra > 0) {
        this.extraImages = this.rowWidth - extra
      }
    },
    loadedArtists: async function () {
      this.version++
      this.martists = []
      this.maxChunks = Math.ceil(this.artists.length / this.chunkSize)
      this.loadedChunks = 0
      if((this.maxChunks < this.maxInitialChunks) || (window.scrollY > 400) || 
        (this.$store.state.requestedScrollY > 400) || (this.$k.isPre())) {
        this.martists = this.artists
        this.setExtraImages()
        this.loadedChunks = this.maxChunks
        this.initialLoadComplete = true
        this.scrolled = true
        this.$emit('load', 'full')
        this.$store.commit('setPageLoaded', true)
      }
      else {
        this.loadChunkSync(0)
        this.$emit('load', 'partial')
        this.loading = true
        const ver = this.version
        for(let i = 1; i < this.maxInitialChunks; i++){
          await this.loadChunk(i, ver)
          this.loadedChunks = i
        }
        
        this.initialLoadComplete = true
        this.loading = false
        if((!this.scrolled) && (window.scrollY > 400)) {
          this.finishLoading()
        }
        
      }
    },
    finishLoading: async function () {
      this.scrolled = true
      if(this.loadedChunks < this.maxChunks) {
        const ver = this.version
        const start = this.maxInitialChunks
        for(let i = start; i <= this.maxChunks; i++){
          await this.loadChunk(i, ver)
          this.loadedChunks = i
        }
        
        
        this.setExtraImages()
      }
    },
    loadChunkSync: function (chunkNum) {
      let slNum = chunkNum * this.chunkSize
      if(slNum > this.artists.length) {
        slNum = this.artists.length
      }
      this.martists = this.artists.slice(0, slNum)
      
    },
    loadChunk: async function (chunkNum, version) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          try{
            if(version !== this.version){
              resolve('aborted')
              return
            }
            this.loadChunkSync(chunkNum)
            resolve('ok')
          }
          catch(err) {
            reject(err)
          }
          
        }, 500)
        
      })
    }
  },
  watch: {
    artists: function () {
      this.scrolled = false
      this.pageSettings = '' + new Date().getTime()
      this.loadedArtists()
    }
  }
}
</script>

<style>

</style>
